<template>
  <div class="mt-4">
    <div class="flex w-full justify-center items-center bg-gray-100 p-1 py-4 text-xs sm:text-sm">
      <select v-model="selectedActivity" v-if="!disableSelect" name="activity" id="activity" class="bg-transparent" @change="updateActivity">
        <option value="">Toutes les activités</option>
        <option v-for="item in items" :key="item" :value="item">{{ item }}</option>
      </select>
      <span v-else>
        <span v-for="item in items" :key="item">
          {{ item }}
        </span>
      </span>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, ref } from 'vue';

defineProps({
  items: {
    type: Array,
    default: () => []
  },
  disableSelect: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['updateActivity']);

const selectedActivity = ref('');

const updateActivity = () => {
  emit('updateActivity', selectedActivity.value);
};

</script>
